var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-content" },
      [
        _c(
          "b-field",
          { staticClass: "mb-6", attrs: { label: "Nombre del archivo" } },
          [
            _c("div", { staticClass: "field has-addons" }, [
              _c(
                "p",
                { staticClass: "control is-expanded" },
                [
                  _c("b-input", {
                    ref: "searchInput",
                    attrs: {
                      type: "text",
                      maxlength: "100",
                      placeholder:
                        "Ej: Documentos a ser eliminados (DD-MM-YYYY)'",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.downloadSearchResults.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.searchResultName,
                      callback: function ($$v) {
                        _vm.searchResultName = $$v
                      },
                      expression: "searchResultName",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "mt-0 pt-0 help" }, [
                    _vm._v(
                      "(Opcional) Nombre del archivo una vez descargado. Por defecto es 'ResultadoDeBusqueda.pdf'."
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.invalidNameMessage
                    ? _c("span", { staticClass: "help has-text-danger" }, [
                        _vm._v(_vm._s(_vm.invalidNameMessage)),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "control" }, [
                _c("a", { staticClass: "button is-static" }, [
                  _vm._v(
                    "\n            " + _vm._s(_vm.extension) + "\n          "
                  ),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "field has-addons mt-6" }, [
          _c(
            "p",
            { staticClass: "control is-expanded" },
            [
              _c(
                "b-field",
                { staticClass: "mb-0 pb-0", attrs: { label: "Descripción" } },
                [
                  _c("b-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: "250",
                      placeholder:
                        "Ej: Documentos subidos a la plataforma a partir de la fecha DD-MM-YYYY que se encuentran dentro de la carpeta 'Actas'",
                    },
                    model: {
                      value: _vm.searchResultDescription,
                      callback: function ($$v) {
                        _vm.searchResultDescription = $$v
                      },
                      expression: "searchResultDescription",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "mt-0 pt-0 help" }, [
                _vm._v(
                  "(Opcional) Esta descripción será añadida dentro del documento una vez generado."
                ),
              ]),
            ],
            1
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "card-footer" }, [
      _c(
        "a",
        {
          staticClass: "card-footer-item",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$parent.close()
            },
          },
        },
        [_vm._v("Cancelar")]
      ),
      _vm._v(" "),
      !_vm.invalidName
        ? _c(
            "a",
            {
              staticClass: "card-footer-item has-text-weight-bold is-uppercase",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.downloadSearchResults.apply(null, arguments)
                },
              },
            },
            [_vm._v("Descargar")]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("p", { staticClass: "card-header-title" }, [
        _vm._v(" Descargar resultado de búsqueda"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field m-5" }, [
      _c("div", { staticClass: "notification is-primary" }, [
        _c("i", { staticClass: "fas fa-info-circle fa-fw" }),
        _vm._v(" Sólo podrá descargar hasta "),
        _c("b", [_vm._v("300")]),
        _vm._v(
          " documentos a la vez. Utilice los filtros para realizar una búsqueda más específica.\n    "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }